import { render, staticRenderFns } from "./CFDIs.vue?vue&type=template&id=0938e8cc"
import script from "./CFDIs.vue?vue&type=script&lang=js"
export * from "./CFDIs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports